import { createSlice } from "@reduxjs/toolkit";

const initialState= {
    groups: null,
}

const adminRbacSlice = createSlice({
    name: "adminrbac",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
         .addCase('LOGOUT', (state) => {
            Object.assign(state, initialState);
         })
    },
    reducers:{
        storeGroups: (state, action) => {
            state.groups= action.payload;
        },
        addGroupToStore: (state, action) => {
            state.groups= [...state.groups, action.payload];
        },
        editGroupInStore: (state, action) => {
            state.groups= state.groups.map((group)=>{
                if(action.payload && group.id === action.payload.id){
                    return action.payload;
                }else{
                    return group;
                }
            });
        },
        deleteRbacFromStore: (state, action) => {
            state.groups= state.groups.filter((rbac)=>{
                return rbac.id !== action.payload
            }) 
        },
    }
})

export const { storeGroups, addGroupToStore, editGroupInStore, deleteRbacFromStore } = adminRbacSlice.actions
export default adminRbacSlice.reducer